export const ALL_PERMISSIONS = [
    'panel:dashboard',
    'panel:pagos',
    'panel:gestion_acelerador',
    'panel:crear_acuerdo',
    'panel:registro_financiero',
    'panel:inversiones',
    'panel:usuarios',
    'panel:perfil_admin',
    'panel:retiros',
    'panel:pagos_globales',
    'panel:pequenos_duenos',
    'panel:reportes',
    'panel:club_beneficios',
    'panel:notificaciones',
    'panel:soporte',
  //  'panel:utilidades',
    'panel:auditoria',
    'panel:configuracion',
    'users:read',
    'users:update',
    'users:update_role',
    'users:delete',
    'agreements:create',
    'agreements:cancel',
    'agreements:update',
    'withdrawals:process',
    'finances:assign_gains',
    'finances:revert_gains',
    'finances:adjust_balance',
    'platform_settings:update',
    'support:handle_tickets',
    'maintenance:run_tasks'
];
